var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('h1',{staticClass:"font-weight-bold mt-5"},[_vm._v(_vm._s(_vm.current.name))]),_c('small',[_vm._v("Settings")])]),_c('hr',{staticClass:"my-5"}),_c('section',[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }